import '../../../css/vendor/jquery.mobile-1.3.1.min.css';
import '../../../css/vendor/jquery-mobile-fluid960.min.css';
import '../../../css/vendor/jqm-icon-pack-1.1-original.css';
import '../../../core/app/styles/boilerplate_style.css';
import '../../../core/app/styles/typography.styl';
import '../../../core/app/styles/softwear-custom.styl';

require('@shared/app/scripts/app');
require('../../../locale/angular-locale_nl-nl');

/**
 * @ngdoc overview
 * @name v6CoreModule
 * @description
 * Core module of the Softwear6 application.
 */
angular.module('v6CoreModule', ['sharedModule']);
